import React from "react";
import { Button } from "react-bootstrap";
import { WarningModal } from "../../../components";

const ValidationPopup = ({
  showModal,
  handleConfirmClick,
  handleCancelClick,
}) => {
  return (
    <WarningModal show={showModal} onHide={handleCancelClick}>
      <div className="remove-text">
        <h4 className="fw-600 ft-22">Attention Required</h4>
        <h5 className="fw-400 ft-18">
          The modified data have impact in 'Applicable To' step.
        </h5>
        <p> Do you want to proceed?</p>
        <Button className="remove-btn mr-4" onClick={handleConfirmClick}>
          Yes
        </Button>
        <Button className="cancel-btn" onClick={handleCancelClick}>
          No
        </Button>
      </div>
    </WarningModal>
  );
};

export default ValidationPopup;
